import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  apiUrl = environment.API_URL2;
 
  constructor(private http : HttpClient) { }

  //Login/Login
  login(params){
    
    return this.http.post(`${this.apiUrl}/login`,params);
  }
  register(params){
    //const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });
    //{ headers: reqHeader }
    return this.http.post(`${this.apiUrl}/registerNew`,params);
  }
  verifyUser(params){
    return this.http.post(`${this.apiUrl}/verifyUser`,params);
  }
  verifyUse(params){
    return this.http.post(`${this.apiUrl}/verifyUser`,params);
  }
  verifyOTPNew(params){
    return this.http.post(`${this.apiUrl}/verifyOTPNew`,params);
  }

  forgotPassword(params){
    return this.http.post(`${this.apiUrl}/mobilePassword`,params);
  }
  updatePassword(params){
    return this.http.post(`${this.apiUrl}/updatepassword`,params);
  }
  getUserInfo(id){
    return this.http.get(`${this.apiUrl}/usermanagement/getUserById/${id}`);
  }
  getOTP(params){
    return this.http.post(`${this.apiUrl}/getotp`,params);
  }
  getotpNew(params){
    return this.http.post(`${this.apiUrl}/getotpNew`,params);
  }
  verifyUserNew(params){
    return this.http.post(`${this.apiUrl}/verifyUserNew`,params);
  }
  
  cpoStationDetailsByClientId(user_id,client_id,params){
    
    return this.http.post(`${this.apiUrl}/user/cpoStationDetailsByClientId/${user_id}/${client_id}`,params);
  }

}